import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const getCoachingStatsQuery = gql`
  query GetCoachingStats($request: GetCoachingStatsInput!) {
    getCoachingStats(request: $request) {
      userId
      coachingStatsForPeriods {
        period {
          periodType
          year
          month
          week
        }

        associateDetails {
          userId
          associateStatus
          associateType
          coachings
          coachingRequirement
          contactReviews
          unopenedContactReviews
          include
          alias
        }
      }
    }
  }
`;

export const getBatchCoachingStatsQuery = gql`
  query GetBatchCoachingStats($inputs: [GetCoachingStatsInput!]!) {
    getBatchCoachingStats(inputs: $inputs) {
      results {
        userId
        coachingStatsForPeriods {
          period {
            periodType
            year
            month
            week
          }
          associateDetails {
            userId
            associateStatus
            associateType
            coachings
            coachingRequirement
            contactReviews
            unopenedContactReviews
            include
            alias
          }
        }
      }
    }
  }
`;
